import * as React from 'react';
import { toast } from 'react-toastify';
import { useObservable } from 'react-use-observable';

import { useFormikContext } from 'formik';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import financialService from 'v2/services/financial';

import type { NewBankAccount } from '../form';
import { Input } from '../Input';
import { Layout } from '../Layout';

function Verify(_props: Partial<Record<string, any>>) {
  const { values } = useFormikContext<NewBankAccount>();
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const emailSplited = user?.email?.split('@');
  const emailRendered = user && `*****${emailSplited[0].slice(-3)}@${emailSplited[1]}`;

  const cellphone = user?.cell_phone?.toString();
  const cellphoneAreacode = cellphone ? cellphone.slice(0, 2) : '';
  const cellphoneLastTwoNumbers = cellphone ? cellphone.slice(-2) : '';
  const cellphoneRendered = user && `(${cellphoneAreacode})-9****-**${cellphoneLastTwoNumbers}`;

  const resendVerificationcode = async (newBankAccountId: number) => {
    try {
      await financialService.resendVerificationCode(newBankAccountId);
      toast.success('Código de verificação reenviado com sucesso!');
    } catch (err) {
      toast.error('Algo de errado aconteceu, tente novamente');
      console.error(err);
    }
  };

  return (
    <Layout
      title='Validação de conta'
      description={
        <span className='text-sm'>
          Para finalizar, insira o código de verificação de 6 dígitos enviado para o e-mail{' '}
          <strong>{emailRendered}</strong> e por SMS para <strong>{cellphoneRendered}</strong>
        </span>
      }
    >
      <div className='my-8'>
        <Input
          name='verify_code'
          label='Código de verificação*'
          placeholder='000000'
          mask='number'
          inputProps={{
            maxLength: 6
          }}
          inputMode='numeric'
        />
        <p className='mt-4! text-sm'>
          Nâo recebeu o código?{' '}
          <span onClick={() => resendVerificationcode(values.id)} className='text-primary cursor-pointer'>
            Reenviar código de verificação
          </span>
        </p>
      </div>
    </Layout>
  );
}

export { Verify };
